import React from "react";
import "./error.css"; 
import { Link } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorImg from "../../assets/images/error404.svg";
import Header from "../../components/header/Header";  
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";


function Error(){
    return(
        <>
          <Header /> 
          <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pt_20 mt_30">
            <div class="error_box">
            <div class="error_box_in">
              <img src={ErrorImg} alt="error" className="img-fluid" />
              <div className="mt_30 pt_30 d_flex align_center justify_sp_center">
               <Link to="/" class="saveForm"><ArrowBackIcon /> Go to Home</Link>
               </div>
            </div>
            </div>
          </div>
        </div>
        </div>
        </div>
         <Subscribe /> 
        <Footer />

        </>
    )
}

export default Error;


